module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_fondo_7.48a919e6.png";